import Site from '../models/site';
import { SITE_TEMPLATES } from './site-template';

export const SITES: Array<Site> = [Site.getInstanceFromObject({
    id: 'a5afe048-7ebd-4d94-a527-1673de918c56',
    name: 'Bangalore',
    siteTemplate: SITE_TEMPLATES[0].id,
})];